import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const linksRapidos = [
    { label: 'Início', to: '/' },
    { label: 'Apresentação Comercial', href:"/downloads/ROSA SA  APRESENTAÇÃO COMERCIAL.pdf", download :"ROSA SA  APRESENTAÇÃO COMERCIAL.pdf" },
    { label: 'Serviços', to: '/servicos' },
    { label: 'Produtos', to: '/produtos' },
    { label: 'Contato', to: '/contato' },
  ];

  return (
    <footer className="relative overflow-hidden">
      {/* BACKDROP: novo estilo (sem textura antiga) */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-emerald-950 via-emerald-900 to-emerald-800" />
        {/* formas decorativas minimalistas */}
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-emerald-700/20 blur-3xl" />
        <div className="absolute -bottom-24 -left-24 w-[28rem] h-[28rem] rounded-full bg-green-600/10 blur-3xl" />
        {/* linha de identidade */}
        <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-emerald-400 via-green-400 to-emerald-400" />
      </div>

      {/* CONTEÚDO PRINCIPAL */}
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          {/* Marca & texto */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4">
              <img src="/logo.png" alt="Usina Rosa" className="h-12 w-auto" />
              <span className="text-emerald-50 text-2xl font-extrabold">Usina Rosa S/A</span>
            </div>
            <p className="mt-4 text-emerald-100/80 leading-relaxed max-w-md">
              Tradição e tecnologia na produção de etanol e derivados. Soluções confiáveis para abastecer sua operação com qualidade, eficiência e transparência.
            </p>
          </div>

          {/* Links Rápidos como chips/pills */}
          <nav className="lg:col-span-7" aria-label="Links Rápidos">
            <h5 className="text-emerald-50 text-xl font-bold mb-4">Links Rápidos</h5>
            <ul className="flex flex-wrap gap-3">
              {linksRapidos.map((item) => (
                <li key={item.label}>
                  {item.to ? (
                    <Link
                      to={item.to}
                      className="inline-flex items-center rounded-full border border-white/15 bg-white/5 px-4 py-2 text-emerald-50/90 hover:text-white hover:bg-white/10 hover:border-white/25 transition-colors"
                    >
                      {item.label}
                    </Link>
                  ) : (
                    <a
                      href={item.href}
                      download={item.download}
                      className="inline-flex items-center rounded-full border border-white/15 bg-white/5 px-4 py-2 text-emerald-50/90 hover:text-white hover:bg-white/10 hover:border-white/25 transition-colors"
                    >
                      {item.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>

      {/* BARRA INFERIOR */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 text-emerald-100/80 text-sm flex flex-col md:flex-row items-center justify-between gap-3">
          <span>© {currentYear} Usina Rosa S/A. Todos os direitos reservados.</span>
          <span className="opacity-80">Qualidade que gera energia para o futuro.</span>
        </div>
      </div>
    </footer>
  );
}
